import React, { useEffect, useState } from 'react';

export default function RecentlyViewed() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const viewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
    setProducts(viewed.slice(0, 5));
  }, []);

  if (products.length === 0) return null;

  return (
    <div style={{ marginBottom: '32px' }}>
      <h3 style={{ fontSize: '16px', fontWeight: '700', margin: '0 0 16px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span>👀</span> Vus récemment
      </h3>

      <div
        style={{
          display: 'flex',
          gap: '12px',
          overflowX: 'auto',
          paddingBottom: '8px',
          scrollBehavior: 'smooth',
        }}
      >
        {products.map((product, idx) => (
          <div
            key={idx}
            style={{
              flex: '0 0 140px',
              background: 'var(--bg-primary)',
              borderRadius: '8px',
              padding: '12px',
              border: '1px solid var(--border-color)',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = 'var(--shadow-md)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <div
              style={{
                background: 'linear-gradient(135deg, #f0f4f8 0%, #e2e8f0 100%)',
                borderRadius: '6px',
                height: '80px',
                marginBottom: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '32px',
              }}
            >
              📦
            </div>
            <p style={{ margin: 0, fontSize: '11px', fontWeight: '600', color: 'var(--text-primary)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {product.name}
            </p>
            <p style={{ margin: '4px 0 0 0', fontSize: '12px', fontWeight: '700', color: '#6366f1' }}>
              ${product.price}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
